export default __webpack_public_path__ + "static/icoBenefit3-16a0db43c68f0aa1ba35cb68d560d215.svg";